class FixedIsi {
  constructor() {
    this.fixed_isi         = document.querySelector('.isi .fixed')
    this.fixed_isi_height  = this.fixed_isi.clientHeight
    this.static_isi        = document.querySelector('#isi')
    this.static_isi_offset = 0
    this.contactForm = document.getElementById('block-getintouchformtray')
    this.contactFormOpenBtn = this.fixed_isi.querySelector('.contact-form-trigger')
    this.contactFormOpenBtnStaticISI = this.static_isi.querySelector('.contact-form-trigger')
    this.contactFormCloseBtn = this.contactForm.querySelector('.contact-form-trigger')
    this.contactFormOpen = false

    window.addEventListener('scroll', () => {
      this.hideShowISI()
    })

    this.contactFormOpenBtn.addEventListener('click', () => {
      this.fixed_isi.addEventListener('transitionend', () => {
        this.showContactForm()
      }, {once: true})

      this.hideISI()
    })
    this.contactFormOpenBtnStaticISI.addEventListener('click', () => {
      this.fixed_isi.addEventListener('transitionend', () => {
      }, {once: true})

      this.hideISI()
      this.showContactForm()
    })
    this.contactFormCloseBtn.addEventListener('click', () => {
      this.contactForm.addEventListener('transitionend', () => {
        this.hideShowISI()
      }, {once: true})

      this.hideContactForm()
    })

    this.hideShowISI()
  }

  calculateOffset() {
    this.static_isi_offset = this.static_isi.getBoundingClientRect().top + this.fixed_isi_height - window.innerHeight + window.scrollY
  }

  hideShowISI() {
    if (this.contactFormOpen) {
      return
    }
    this.calculateOffset()

    if (window.pageYOffset > this.static_isi_offset) {
      this.hideISI()
      document.body.classList.remove('sticky-isi')
    } else {
      document.body.classList.add('sticky-isi')
      this.showISI()
    }
  }
  hideISI() {
    this.fixed_isi.classList.add('hidden')
  }
  showISI() {
    this.fixed_isi.classList.remove('hidden')
  }
  showContactForm() {
    this.contactForm.classList.add('active')
    this.contactFormOpen = true
  }
  hideContactForm() {
    this.contactForm.classList.remove('active')
    this.contactFormOpen = false
  }
}

export default FixedIsi



// WEBPACK FOOTER //
// ./js/classes/fixed-isi.js